import TagManager from 'react-gtm-module';

export const sendEvent = (eventName, eventProperties) => {
  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      ...eventProperties,
    },
  });
};
